import type { ButtonHTMLAttributes, ReactNode } from 'react'

type PrimaryButtonProps = {
  children: ReactNode
  href?: string
  target?: string
  rel?: string
  className?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

const PRIMARY_BUTTON_BASE =
  'inline-flex items-center justify-center rounded-lg bg-white px-5 py-2.5 text-base font-semibold text-primary no-underline shadow-sm transition-colors hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-60'

export default function PrimaryButton({
  children,
  href,
  target,
  rel,
  className,
  type = 'button',
  ...buttonProps
}: PrimaryButtonProps) {
  const classes = className
    ? `${PRIMARY_BUTTON_BASE} ${className}`
    : PRIMARY_BUTTON_BASE

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={classes}
      >
        {children}
      </a>
    )
  }

  return (
    <button type={type} className={classes} {...buttonProps}>
      {children}
    </button>
  )
}
